// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.template-elements[data-v-f634f04c] {
  position: fixed;
  left: -100000%;
  top: -100000%;
}`, "",{"version":3,"sources":["webpack://./src/SharedWeb/scripts/dynamic-component-editor/inspector/Inspector-elements/DynamicComponentPreviewGrid.vue","webpack://./DynamicComponentPreviewGrid.vue"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,cAAA;EACA,aAAA;ACDF","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\n.template-elements {\n  position: fixed;\n  left: -100000%;\n  top: -100000%;\n}\n",".template-elements {\n  position: fixed;\n  left: -100000%;\n  top: -100000%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
